import { ReactNodeViewRenderer } from '@tiptap/react'

import { ImageNode as SharedImageNode } from '~shared/richtext/nodes/image.node'

import { ImageNodeViewLive } from './ImageNodeView'

/**
 * Extends our custom `ImageNode` with client-only features.
 */
export const ImageNode = SharedImageNode.extend({
  addNodeView() {
    return ReactNodeViewRenderer(ImageNodeViewLive)
  },
})
